export const currencyUnit = state => {
  const {
    prices
  } = state
  if (!prices || !prices.length) {
    return '元'
  }
  return prices[0].currencyUnit
}

export const priceMap = state => {
  const {
    prices
  } = state
  const result = {}
  prices.forEach(price => {
    result[price.id] = price
  })
  return result
}

export const count = state => state.selectedSeats.length

export const totalAmount = (state, getters) => {
  const {
    selectedSeats,
  } = state
  const {
    priceMap,
  } = getters
  return selectedSeats
    .map(({ priceId }) => Number(priceMap[priceId].amount))
    .reduce((a, b) => a + b, 0)
}



// WEBPACK FOOTER //
// ./src/store/seat/getters.js